// Wait for all scripts to load, including deferred theme scripts
window.addEventListener('load', function() {
  // Small delay to ensure theme scripts are fully initialized
  setTimeout(function() {
  
  // 🚫 CRITICAL: Prevent API flooding by blocking realtime-klaviyo calls on cart page
  if (window.location.pathname.includes('/cart')) {
    // Set global flag to disable realtime klaviyo functions
    window.npoDisableRealtimeKlaviyo = true;
    
    // Intercept and block ALL realtime-klaviyo requests on cart page
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (url && url.includes('realtime-klaviyo')) {
        // Return fake success response to prevent errors
        return Promise.resolve({
          ok: true,
          status: 200,
          json: () => Promise.resolve({ 
            success: true, 
            hasAccess: true, 
            blocked: true,
            reason: 'API flood protection active on cart page'
          })
        });
      }
      return originalFetch.apply(this, arguments);
    };
    
    // Also block any existing XMLHttpRequest calls to realtime-klaviyo
    const originalXHR = window.XMLHttpRequest;
    window.XMLHttpRequest = function() {
      const xhr = new originalXHR();
      const originalOpen = xhr.open;
      xhr.open = function(method, url, ...args) {
        if (url && url.includes('realtime-klaviyo')) {
          return;
        }
        return originalOpen.apply(this, [method, url, ...args]);
      };
      return xhr;
    };
  }
  
  // Initialize cart quantity restrictions for NPO restricted products
  function initializeCartQuantityRestrictions() {
    const restrictedItems = document.querySelectorAll('.npo-cart-restricted');
    
    restrictedItems.forEach(function(container, index) {
      const quantityInput = container.querySelector('.npo-cart-input');
      const plusButton = container.querySelector('.npo-cart-plus');
      
      if (!quantityInput) {
        return;
      }
      
      const maxQuantity = parseInt(quantityInput.getAttribute('data-npo-max-quantity'));
      const productTitle = quantityInput.getAttribute('data-product-title');
      const productId = quantityInput.getAttribute('data-product-id');
      const currentQuantity = parseInt(quantityInput.value, 10) || 0;
      
      if (isNaN(maxQuantity) || maxQuantity <= 0) {
        return;
      }
      
      // 🔒 ENHANCED: Check if this is a product-level restriction (applies to all variants)
      function getProductTotalQuantity(productId) {
        let totalQuantity = 0;
        const allRestrictedInputs = document.querySelectorAll('.npo-cart-input[data-npo-restricted="true"]');
        
        allRestrictedInputs.forEach(function(input) {
          const inputProductId = input.getAttribute('data-product-id');
          if (inputProductId === productId) {
            totalQuantity += parseInt(input.value, 10) || 0;
          }
        });
        
        return totalQuantity;
      }
      
      // 🔒 SECURITY: Server-side validation for existing over-limit quantities
      // Check using effective max (will be updated when restriction data loads)
      function checkAndAdjustQuantity() {
        const effectiveMax = parseInt(quantityInput.getAttribute('data-npo-effective-max'), 10) || maxQuantity;
        const currentProductTotal = getProductTotalQuantity(productId);
        
        if (currentProductTotal > effectiveMax) {
        // Get the line item key from the input element
        const lineItemKey = quantityInput.getAttribute('data-line-item-key');
        
        // First validate with server using the ORIGINAL over-limit quantity
          validateCartUpdate(lineItemKey, currentQuantity, productTitle, productId).then(function(isValid) {
          if (!isValid) {
              quantityInput.value = Math.max(0, effectiveMax - (currentProductTotal - currentQuantity));
              showNotification('Quantity adjusted - maximum ' + effectiveMax + ' remaining (considering previous orders)', 'success');
            
            // Trigger cart update with corrected quantity
            const changeEvent = new Event('keyup', { bubbles: true });
            changeEvent.key = 'Enter';
            quantityInput.dispatchEvent(changeEvent);
          }
        });
        }
      }
      
      // Initial check
      checkAndAdjustQuantity();
      
      // Re-check when restriction data is updated
      quantityInput.addEventListener('npo-restriction-updated', checkAndAdjustQuantity);
      
      // Plus button handling is now consolidated in script.cart.js to prevent conflicts
      
      // 🔒 SECURITY: Real-time input validation with server check
      let lastValidatedValue = currentQuantity;
      
      quantityInput.addEventListener('input', function() {
        const attemptedValue = parseInt(this.value, 10) || 0;
        const otherVariantsTotal = getProductTotalQuantity(productId) - parseInt(quantityInput.value, 10);
        const newProductTotal = otherVariantsTotal + attemptedValue;
        
        // UPDATED: Use effective max (considering previous purchases) instead of just maxQuantity
        const effectiveMax = parseInt(this.getAttribute('data-npo-effective-max'), 10) || maxQuantity;
        const remainingQuantity = parseInt(this.getAttribute('data-npo-remaining-quantity'), 10) || maxQuantity;
        const previousPurchases = parseInt(this.getAttribute('data-npo-previous-purchases'), 10) || 0;
        
        if (newProductTotal > effectiveMax) {
          // Visual feedback
          this.style.borderColor = '#dc3545';
          this.title = `Maximum ${effectiveMax} remaining (${previousPurchases} already ordered, ${maxQuantity} total limit)`;
          
          // Get the line item key from the input element
          const lineItemKey = this.getAttribute('data-line-item-key');
          
          // Validate with server using the ATTEMPTED quantity (before correction)
          validateCartUpdate(lineItemKey, attemptedValue, productTitle, productId).then(function(isValid) {
            if (!isValid) {
              // Revert to last valid value
              quantityInput.value = lastValidatedValue;
              quantityInput.style.borderColor = '';
              quantityInput.title = '';
              
              // Show notification about exceeding limit
              if (previousPurchases > 0 && remainingQuantity === 0) {
                // 🎯 CENTRALIZED TOAST: Use global toast manager
                if (window.cartProtectionManager?.toastManager) {
                  window.cartProtectionManager.toastManager.showQuantityLimitToast({
                    maxQuantity: maxQuantity,
                    previousPurchases: previousPurchases,
                    currentInCart: 0, // Can't add any more
                    attemptedQuantity: attemptedValue,
                    isMultiVariant: false,
                    reason: 'remaining-exceeded'
                  });
                } else {
                  // Fallback for when toast manager not available
                  showNotification(`You cannot add any more to cart. You have already ordered ${previousPurchases}. The maximum order quantity is ${maxQuantity}.`, 'error');
                }
              } else if (previousPurchases > 0) {
                // 🎯 CENTRALIZED TOAST: Use global toast manager
                if (window.cartProtectionManager?.toastManager) {
                  window.cartProtectionManager.toastManager.showQuantityLimitToast({
                    maxQuantity: maxQuantity,
                    previousPurchases: previousPurchases,
                    currentInCart: remainingQuantity,
                    attemptedQuantity: attemptedValue,
                    isMultiVariant: false,
                    reason: 'remaining-exceeded'
                  });
                } else {
                  // Fallback for when toast manager not available
                  showNotification(`You can only add ${remainingQuantity} more to cart. You have already ordered ${previousPurchases}.`, 'warning');
                }
              } else {
                // 🎯 CENTRALIZED TOAST: Use global toast manager
                if (window.cartProtectionManager?.toastManager) {
                  window.cartProtectionManager.toastManager.showQuantityLimitToast({
                    maxQuantity: maxQuantity,
                    previousPurchases: 0,
                    currentInCart: attemptedValue,
                    attemptedQuantity: attemptedValue,
                    isMultiVariant: false,
                    reason: 'exceeds-limit'
                  });
                } else {
                  // Fallback for when toast manager not available
                  showNotification(`Maximum ${maxQuantity} allowed per customer`, 'warning');
                }
              }
            } else {
              lastValidatedValue = attemptedValue;
            }
          }).catch(function(error) {
            quantityInput.value = lastValidatedValue;
            quantityInput.style.borderColor = '';
            quantityInput.title = '';
          });
        } else {
          // Valid input
          this.style.borderColor = '';
          this.title = '';
          lastValidatedValue = attemptedValue;
        }
      });
    });
  }
  
  // 🔒 Server-side validation before cart updates
  const pendingValidations = new Map();
  let lastNotificationTime = 0;
  let activeNotification = null;
  let notificationQueue = [];
  let validationCounter = 0;
  
  // Enhanced notification system to prevent ALL overlapping alerts
  function showNotification(message, type = 'error') {
    const now = Date.now();
    
    // Anti-spam: Only show one notification per second
    if (now - lastNotificationTime < 1000) {
      return;
    }
    
    // Remove any existing notification first
    if (activeNotification) {
      activeNotification.remove();
      activeNotification = null;
    }
    
    lastNotificationTime = now;
    
    const colors = {
      success: '#28a745',
      error: '#dc3545', 
      warning: '#fff3cd'
    };
    
    const notice = document.createElement('div');
    notice.textContent = message;
    
    const textColor = type === 'warning' ? '#856404' : 'white';
    const borderStyle = type === 'warning' ? 'border: 1px solid #ffeaa7;' : '';
    
    notice.style.cssText = 'position: fixed; top: 20px; right: 20px; background: ' + (colors[type] || colors.error) + '; color: ' + textColor + '; ' + borderStyle + ' padding: 12px 20px; border-radius: 5px; font-size: 14px; font-weight: 500; z-index: 999999; box-shadow: 0 2px 10px rgba(0,0,0,0.2); max-width: 300px; animation: slideIn 0.3s ease-out;';
    
    // Add CSS animation
    if (!document.getElementById('npo-notification-styles')) {
      const style = document.createElement('style');
      style.id = 'npo-notification-styles';
      style.textContent = `
        @keyframes slideIn { 
          from { transform: translateX(100%); opacity: 0; } 
          to { transform: translateX(0); opacity: 1; } 
        }
        
        /* Mobile-specific centering for cart notifications */
        @media (max-width: 768px) {
          div[style*="position: fixed"][style*="top: 20px"][style*="right: 20px"] {
            left: 50% !important;
            right: auto !important;
            transform: translateX(-50%) !important;
            max-width: calc(100vw - 40px) !important;
            width: auto !important;
          }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(notice);
    activeNotification = notice;
    
    // Auto-remove after delay
    const delay = type === 'success' ? 3000 : 5000;
    setTimeout(() => {
      if (activeNotification === notice) {
        notice.remove();
        activeNotification = null;
      }
    }, delay);
  }
  
  async function validateCartUpdate(lineItemKey, newQuantity, productTitle, productId) {
    validationCounter++;
    
    // Prevent duplicate validation requests
    const requestKey = lineItemKey + '-' + newQuantity;
    if (pendingValidations.has(requestKey)) {
      return await pendingValidations.get(requestKey);
    }
    
    try {
      // Create validation promise and store it to prevent duplicates
      const validationPromise = (async () => {
        // Collect all cart items for the same product for product-level validation
        const allCartUpdates = {};
        const allRestrictedInputs = document.querySelectorAll('.npo-cart-input[data-npo-restricted="true"]');
        
        allRestrictedInputs.forEach(function(input) {
          const inputProductId = input.getAttribute('data-product-id');
          const inputLineItemKey = input.getAttribute('data-line-item-key');
          const inputQuantity = input === document.querySelector(`[data-line-item-key="${lineItemKey}"]`) ? newQuantity : (parseInt(input.value, 10) || 0);
          
          if (inputProductId === productId) {
            allCartUpdates[inputLineItemKey] = inputQuantity;
          }
        });
        
        const response = await fetch('https://newsletter-priority-orders-minimal.vercel.app/api/cart-handler', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: allCartUpdates,
            productTitle: productTitle,
            productId: productId,
            lineItemKey: lineItemKey // The specific line item being changed
          })
        });
        
        const result = await response.json();
        
        if (!result.valid) {
          showNotification('❌ ' + (result.message || 'Quantity limit exceeded'), 'error');
          return false;
        }
        
        return true;
      })();
      
      pendingValidations.set(requestKey, validationPromise);
      const result = await validationPromise;
      pendingValidations.delete(requestKey);
      
      return result;
    } catch (error) {
      pendingValidations.delete(requestKey);
      
      // 🔒 SECURITY: If validation fails, BLOCK the update (fail-closed)
      showNotification('❌ Network error. Please check your connection and try again.', 'warning');
      
      return false;
    }
  }
  
  // Enhanced AJAX interception for server-side validation
  function interceptCartUpdates() {
    
    // Intercept ALL form submissions on cart page
    document.addEventListener('submit', function(e) {
      
      if (e.target.action && e.target.action.includes('/cart')) {
        
        // Get form data
        const formData = new FormData(e.target);
        const updates = {};
        
        for (let [key, value] of formData.entries()) {
          if (key === 'updates[]' || key.startsWith('updates[')) {
            updates[key] = value;
          }
        }
        
        // Check if any restricted products exceed limits
        for (let [key, quantity] of Object.entries(updates)) {
          const numericQuantity = parseInt(quantity);
          
          // Find the corresponding input to check if it's restricted and get its limit
          const input = document.querySelector(`input[name="${key}"]`);
          if (input) {
            const isRestricted = input.getAttribute('data-npo-restricted') === 'true';
            if (isRestricted) {
              const maxQuantity = parseInt(input.getAttribute('data-npo-max-quantity')) || 3;
              if (numericQuantity > maxQuantity) {
                e.preventDefault();
                e.stopPropagation();
                showNotification(`❌ Cannot submit cart: Maximum ${maxQuantity} allowed for restricted products`, 'error');
                return false;
              }
            } else if (numericQuantity > 50) {
              // Reasonable limit for unrestricted products
              e.preventDefault();
              e.stopPropagation();
              showNotification('❌ Cannot submit cart: Maximum 50 items per product', 'error');
              return false;
            }
          }
        }
      }
    }, true);
    
    // Intercept XMLHttpRequest as well
    const originalXHR = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.send = function(data) {
      return originalXHR.apply(this, arguments);
    };
    
    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function(method, url) {
      this._url = url;
      return originalOpen.apply(this, arguments);
    };
    
    const originalFetch = window.fetch;
    let cartUpdateInProgress = false;
    
    window.fetch = async function(url, options) {
      
      if (url.includes('/cart/change') || url.includes('/cart/update') || 
          (typeof url === 'string' && (url.endsWith('/cart/change.js') || url.endsWith('/cart/update.js')))) {
        
        // Prevent rapid-fire cart updates
        if (cartUpdateInProgress) {
          return Promise.resolve({
            ok: true,
            json: () => Promise.resolve({ 
              success: true,
              blocked: true,
              reason: 'Duplicate request blocked'
            })
          });
        }
        
        cartUpdateInProgress = true;
        
        try {
          let requestBody = null;
          let updates = null;
          
          // Parse request body to get updates
          if (options && options.body) {
            try {
              if (typeof options.body === 'string') {
                if (options.body.startsWith('{')) {
                  requestBody = JSON.parse(options.body);
                } else {
                  // URL-encoded form data
                  const params = new URLSearchParams(options.body);
                  requestBody = {};
                  for (let [key, value] of params.entries()) {
                    requestBody[key] = value;
                  }
                }
              } else if (options.body instanceof FormData) {
                requestBody = {};
                for (let [key, value] of options.body.entries()) {
                  requestBody[key] = value;
                }
              }
            } catch (e) {
              // Ignore parsing errors
            }
          }
          
          if (requestBody && requestBody.updates) {
            updates = requestBody.updates;
          } else if (requestBody && requestBody.id && requestBody.quantity) {
            updates = { [requestBody.id]: requestBody.quantity };
          }
          
          if (updates) {
            
            // Handle single update format (id: quantity)
            if (updates.id && updates.quantity) {
              const attemptedQuantity = parseInt(updates.quantity, 10) || 0;
              
              // Find the restricted input for this line item
              const restrictedInput = document.querySelector(`input[data-line-item-key="${updates.id}"][data-npo-restricted="true"]`);
              
              if (restrictedInput) {
                const maxQuantity = parseInt(restrictedInput.getAttribute('data-npo-max-quantity')) || 3;
                const productTitle = restrictedInput.getAttribute('data-product-title') || 'Restricted Product';
                const productId = restrictedInput.getAttribute('data-product-id');
                
                if (attemptedQuantity > maxQuantity) {
                  
                  cartUpdateInProgress = false;
                  showNotification(`❌ Maximum ${maxQuantity} allowed for ${productTitle}`, 'error');
                  
                  // Return current cart state to prevent theme script breakage
                  try {
                    const currentCartResponse = await originalFetch('/cart.js');
                    const currentCart = await currentCartResponse.json();
                    
                  return Promise.resolve({
                      ok: true,
                      status: 200,
                      json: () => Promise.resolve(currentCart)
                    });
                  } catch (error) {
                    return Promise.resolve({
                      ok: true,
                      status: 200,
                    json: () => Promise.resolve({ 
                        item_count: 0,
                        total_price: 0,
                        items_subtotal_price: 0,
                        total_discount: 0,
                        cart_level_discount_applications: []
                    })
                  });
                  }
                } else if (attemptedQuantity > 50) {
                  
                  cartUpdateInProgress = false;
                  showNotification('❌ Maximum 50 items per product allowed', 'error');
                  
                  // Return current cart state to prevent theme script breakage
                  try {
                    const currentCartResponse = await originalFetch('/cart.js');
                    const currentCart = await currentCartResponse.json();
                    
                  return Promise.resolve({
                      ok: true,
                      status: 200,
                      json: () => Promise.resolve(currentCart)
                    });
                  } catch (error) {
                    return Promise.resolve({
                      ok: true,
                      status: 200,
                    json: () => Promise.resolve({ 
                        item_count: 0,
                        total_price: 0,
                        items_subtotal_price: 0,
                        total_discount: 0,
                        cart_level_discount_applications: []
                    })
                  });
                  }
                } else {
                  
                  // Check if this is a restricted product - validate with server first
                  if (restrictedInput) {
                    
                    const isValid = await validateCartUpdate(updates.id, attemptedQuantity, productTitle, productId);
                    if (!isValid) {
                      
                      cartUpdateInProgress = false;
                      // Instead of returning an error, get current cart state and return it
                      // This prevents the theme script from breaking while keeping the original quantities
                      try {
                        const currentCartResponse = await originalFetch('/cart.js');
                        const currentCart = await currentCartResponse.json();
                        
                      return Promise.resolve({
                          ok: true,
                          status: 200,
                          json: () => Promise.resolve(currentCart)
                        });
                      } catch (error) {
                        // Fallback if cart fetch fails
                        return Promise.resolve({
                          ok: true,
                          status: 200,
                        json: () => Promise.resolve({ 
                            item_count: 0,
                            total_price: 0,
                            items_subtotal_price: 0,
                            total_discount: 0,
                            cart_level_discount_applications: []
                        })
                      });
                      }
                    }
                  }
                }
              }
            } else {
              // Handle bulk updates format (line_item_key: quantity)
              
              for (let [lineItemKey, quantity] of Object.entries(updates)) {
                
                const restrictedInput = document.querySelector(`input[data-line-item-key="${lineItemKey}"][data-npo-restricted="true"]`);
                if (restrictedInput) {
                  const maxQuantity = parseInt(restrictedInput.getAttribute('data-npo-max-quantity')) || 3;
                  const productTitle = restrictedInput.getAttribute('data-product-title') || 'Restricted Product';
                  const productId = restrictedInput.getAttribute('data-product-id');
                  const attemptedQuantity = parseInt(quantity, 10) || 0;
                  
                  const isValid = await validateCartUpdate(lineItemKey, attemptedQuantity, productTitle, productId);
                  if (!isValid) {
                    
                    cartUpdateInProgress = false;
                    // Return current cart state instead of error to prevent theme script breakage
                    try {
                      const currentCartResponse = await originalFetch('/cart.js');
                      const currentCart = await currentCartResponse.json();
                      
                    return Promise.resolve({
                        ok: true,
                        status: 200,
                        json: () => Promise.resolve(currentCart)
                      });
                    } catch (error) {
                      // Fallback if cart fetch fails
                      return Promise.resolve({
                        ok: true,
                        status: 200,
                      json: () => Promise.resolve({ 
                          item_count: 0,
                          total_price: 0,
                          items_subtotal_price: 0,
                          total_discount: 0,
                          cart_level_discount_applications: []
                      })
                    });
                    }
                  }
                }
              }
            }
          }
          
          // If we get here, validation passed - proceed with original request
          
          const result = await originalFetch.apply(this, arguments);
          
          cartUpdateInProgress = false;
          
          return result;
        } catch (error) {
          
          cartUpdateInProgress = false;
          throw error;
        }
      }
      
      return originalFetch.apply(this, arguments);
    };
  }
  
  // Set up cart state monitoring to catch any bypassed updates
  function setupCartStateMonitoring() {
    
    const cartContainer = document.querySelector('#cart-table, .cart-items, .cart');
    if (cartContainer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          // Check for quantity input value changes
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const target = mutation.target;
            if (target.classList.contains('item-qty') && target.getAttribute('data-npo-restricted') === 'true') {
              const currentValue = parseInt(target.value, 10) || 0;
              const maxQuantity = parseInt(target.getAttribute('data-npo-max-quantity')) || 3;
              
              if (currentValue > maxQuantity) {
                
                target.value = maxQuantity;
                showNotification('Quantity corrected to maximum allowed: ' + maxQuantity, 'warning');
              }
            }
          }
          
          // Check for newly added quantity inputs
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                const quantityInputs = node.querySelectorAll ? node.querySelectorAll('.item-qty[data-npo-restricted="true"]') : [];
                quantityInputs.forEach(function(input) {
                  const currentValue = parseInt(input.value, 10) || 0;
                  const maxQuantity = parseInt(input.getAttribute('data-npo-max-quantity')) || 3;
                  
                  if (currentValue > maxQuantity) {
                    
                    input.value = maxQuantity;
                    showNotification('Quantity corrected to maximum allowed: ' + maxQuantity, 'warning');
                  }
                });
              }
            });
          }
        });
      });
      
      observer.observe(cartContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      });
      
    }
    
    // Global input monitoring for any quantity inputs that might be missed
    
    document.addEventListener('input', function(e) {
      if (e.target.classList.contains('item-qty') && e.target.getAttribute('data-npo-restricted') === 'true') {
        const currentValue = parseInt(e.target.value, 10) || 0;
        const maxQuantity = parseInt(e.target.getAttribute('data-npo-max-quantity')) || 3;
        const effectiveMax = parseInt(e.target.getAttribute('data-npo-effective-max'), 10) || maxQuantity;
        const previousPurchases = parseInt(e.target.getAttribute('data-npo-previous-purchases'), 10) || 0;
        
        if (currentValue > effectiveMax) {
          e.target.value = effectiveMax;
          e.preventDefault();
          e.stopPropagation();
          
          // Show appropriate notification
          if (previousPurchases > 0 && effectiveMax === 0) {
            showNotification(`You cannot add any more to cart. You have already ordered ${previousPurchases}. The maximum order quantity is ${maxQuantity}.`, 'error');
          } else if (previousPurchases > 0) {
            showNotification(`You can only add ${effectiveMax} more to cart. You have already ordered ${previousPurchases}.`, 'warning');
          } else {
            showNotification('Maximum ' + effectiveMax + ' allowed', 'warning');
          }
        } else if (currentValue > 50) {
          e.target.value = 50;
          e.preventDefault();
          e.stopPropagation();
          showNotification('Maximum 50 items per product', 'warning');
        }
      }
    }, true);
    
    document.addEventListener('keyup', function(e) {
      if (e.target.classList.contains('item-qty') && e.target.getAttribute('data-npo-restricted') === 'true') {
        const currentValue = parseInt(e.target.value, 10) || 0;
        const maxQuantity = parseInt(e.target.getAttribute('data-npo-max-quantity')) || 3;
        const effectiveMax = parseInt(e.target.getAttribute('data-npo-effective-max'), 10) || maxQuantity;
        const previousPurchases = parseInt(e.target.getAttribute('data-npo-previous-purchases'), 10) || 0;
        
        if (currentValue > effectiveMax) {
          e.target.value = effectiveMax;
          
          // Show appropriate notification
          if (previousPurchases > 0 && effectiveMax === 0) {
            showNotification(`You cannot add any more to cart. You have already ordered ${previousPurchases}. The maximum order quantity is ${maxQuantity}.`, 'error');
          } else if (previousPurchases > 0) {
            showNotification(`You can only add ${effectiveMax} more to cart. You have already ordered ${previousPurchases}.`, 'warning');
          } else {
            showNotification('Maximum ' + effectiveMax + ' allowed', 'warning');
          }
        } else if (currentValue > 50) {
          e.target.value = 50;
          showNotification('Maximum 50 items per product', 'warning');
        }
      }
    }, true);
    
    // Cart form monitoring
    const cartForm = document.querySelector('form[action*="/cart"]');
    if (cartForm) {
      
      cartForm.addEventListener('submit', function(e) {
        
        const formData = new FormData(e.target);
        for (let [key, value] of formData.entries()) {
          
          if (key.includes('updates') || key.includes('quantity')) {
            const quantity = parseInt(value, 10) || 0;
            
            // Find corresponding input to check restrictions
            const input = e.target.querySelector(`input[name="${key}"]`);
            if (input && input.getAttribute('data-npo-restricted') === 'true') {
              const maxQuantity = parseInt(input.getAttribute('data-npo-max-quantity')) || 3;
              const effectiveMax = parseInt(input.getAttribute('data-npo-effective-max'), 10) || maxQuantity;
              const previousPurchases = parseInt(input.getAttribute('data-npo-previous-purchases'), 10) || 0;
                
              if (quantity > effectiveMax) {
                e.preventDefault();
                e.stopPropagation();
                
                if (previousPurchases > 0 && effectiveMax === 0) {
                  showNotification(`Cannot submit: You cannot add any more to cart. You have already ordered ${previousPurchases}. The maximum order quantity is ${maxQuantity}.`, 'error');
                } else if (previousPurchases > 0) {
                  showNotification(`Cannot submit: You can only add ${effectiveMax} more to cart. You have already ordered ${previousPurchases}.`, 'error');
                } else {
                  showNotification('Cannot submit: Maximum ' + effectiveMax + ' allowed for restricted products', 'error');
                }
                return false;
              }
            } else if (quantity > 50) {
              
              e.preventDefault();
              e.stopPropagation();
              showNotification('Cannot submit: Maximum 50 items per product', 'error');
              return false;
            }
          }
        }
      });
    }
  }
  
  // Periodic check to catch any quantity manipulation
  setInterval(function() {
    const restrictedInputs = document.querySelectorAll('.item-qty[data-npo-restricted="true"]');
    restrictedInputs.forEach(function(input) {
      const currentValue = parseInt(input.value, 10) || 0;
      const maxQuantity = parseInt(input.getAttribute('data-npo-max-quantity')) || 3;
      const effectiveMax = parseInt(input.getAttribute('data-npo-effective-max'), 10) || maxQuantity;
      const previousPurchases = parseInt(input.getAttribute('data-npo-previous-purchases'), 10) || 0;
      
      if (currentValue > effectiveMax) {
        input.value = effectiveMax;
        
        if (previousPurchases > 0 && effectiveMax === 0) {
          showNotification(`Quantity auto-corrected: You cannot add any more to cart. You have already ordered ${previousPurchases}.`, 'warning');
        } else if (previousPurchases > 0) {
          showNotification(`Quantity auto-corrected to remaining allowed: ${effectiveMax}`, 'warning');
        } else {
          showNotification('Quantity auto-corrected to maximum: ' + effectiveMax, 'warning');
        }
      }
    });
  }, 2000);
  
  // Initialize all functions
  initializeCartQuantityRestrictions();
  interceptCartUpdates();
  setupCartStateMonitoring();
  
  // Enhanced cart restriction notices with purchase history - make it globally accessible
  let restrictionUpdateTimeout = null;
  let lastUpdateTime = 0;
  window.updateCartRestrictionNotices = function updateCartRestrictionNotices() {
    // Stronger debounce mechanism to prevent duplicate calls
    const now = Date.now();
    if (now - lastUpdateTime < 500) {
      console.log('[Cart NPO] Debouncing duplicate call');
      return;
    }
    
    if (restrictionUpdateTimeout) {
      clearTimeout(restrictionUpdateTimeout);
    }
    
    restrictionUpdateTimeout = setTimeout(() => {
      lastUpdateTime = Date.now();
      const restrictionNotices = document.querySelectorAll('.npo-cart-restriction-notice[data-product-id]');
      
      console.log('[Cart NPO] Found restriction notices:', restrictionNotices.length);
    
    restrictionNotices.forEach(async (notice) => {
      const productId = notice.getAttribute('data-product-id');
      const customerEmail = notice.getAttribute('data-customer-email');
      const maxQuantity = notice.getAttribute('data-max-quantity');
      const textElement = notice.querySelector('.npo-cart-restriction-text');
      
      console.log('[Cart NPO] Processing notice:', {
        productId,
        customerEmail,
        maxQuantity,
        hasTextElement: !!textElement
      });
      
      if (!productId || !textElement) {
        console.log('[Cart NPO] Skipping notice - missing required elements');
        return;
      }
      
      // Try to get customer email from various sources
      let email = customerEmail || 
                  window.NPO_CUSTOMER_EMAIL || 
                  document.querySelector('[data-customer-email]')?.getAttribute('data-customer-email') ||
                  window.npoCustomerEmail;
      
      // Debug customer info
      console.log('[Cart NPO] Customer debug info:', {
        foundEmail: email,
        hasWindowEmail: !!window.NPO_CUSTOMER_EMAIL
      });
      
      if (!email) {
        console.log('[Cart NPO] No customer email found - skipping API call');
        // Still update the notice to remove loading indicator
        textElement.textContent = `📦 Max ${maxQuantity} per customer`;
        textElement.classList.remove('npo-initial-loading');
        return;
      }
      
      try {
        // Fetch purchase history for this product
        console.log('[Cart NPO] Making API call for:', { email, productId });
        
        const response = await fetch('https://newsletter-priority-orders-minimal.vercel.app/api/verify-customer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email,
            productId: productId,
            quantity: 1,
            validationType: 'cart-info'
          })
        });
        
        if (!response.ok) {
          console.warn('[Cart NPO] API call failed for product:', productId, 'Status:', response.status);
          // Remove loading indicator on error
          textElement.textContent = `📦 Max ${maxQuantity} per customer`;
          textElement.classList.remove('npo-initial-loading');
          return;
        }
        
        const result = await response.json();
        console.log('[Cart NPO] API response:', result);
        
        // CRITICAL DEBUG: Individual API detailed response logging
        console.log('🔍 [INDIVIDUAL API DEBUG] Complete response:', {
          url: 'https://newsletter-priority-orders-minimal.vercel.app/api/verify-customer',
          requestBody: {
            email: customerEmail,
            productId: productId,
            validationType: 'cart-info'
          },
          fullResponse: result,
          topLevelPreviousPurchases: result.previousPurchases,
          topLevelMaxQuantity: result.maxQuantityPerCustomer,
          restrictionsArray: result.restrictions,
          firstRestrictionData: result.restrictions && result.restrictions[0] ? {
            previousPurchases: result.restrictions[0].previousPurchases,
            maxQuantityPerCustomer: result.restrictions[0].maxQuantityPerCustomer
          } : null
        });
        
        if (result.restrictions && result.restrictions.length > 0) {
          const restriction = result.restrictions[0];
          console.log('[Cart NPO] Restriction details:', restriction);
          
          // ENHANCED: Check for purchase history at top level (cart-info) OR in restriction (batch mode)
          const maxQuantityPerCustomer = result.maxQuantityPerCustomer || result.topLevelMaxQuantity || restriction.maxQuantityPerCustomer;
          const previousPurchasesData = result.topLevelPreviousPurchases !== undefined ? result.topLevelPreviousPurchases : 
                                       (result.previousPurchases !== undefined ? result.previousPurchases : restriction.previousPurchases);
          const remainingQuantityData = result.remainingQuantity !== undefined ? result.remainingQuantity : restriction.remainingQuantity;
          
          if (maxQuantityPerCustomer && previousPurchasesData !== undefined) {
            const previousPurchases = previousPurchasesData;
            const remainingQuantity = remainingQuantityData !== undefined ? remainingQuantityData : Math.max(0, maxQuantity - previousPurchases);
            
            console.log('[Cart NPO] Updating text with:', {
              previousPurchases,
              maxQuantity,
              remainingQuantity
            });
            
            if (previousPurchases > 0) {
              textElement.textContent = `📦 Max ${maxQuantity} per customer. You have already ordered ${previousPurchases}.`;
              console.log('[Cart NPO] Updated text to show previous purchases:', textElement.textContent);
            } else {
              textElement.textContent = `📦 Max ${maxQuantity} per customer`;
              console.log('[Cart NPO] Updated text to show max only:', textElement.textContent);
            }
            
            // Remove loading indicator class
            textElement.classList.remove('npo-initial-loading');
            
            // CRITICAL: Update quantity input attributes with remaining quantity for validation
            const restrictedContainer = textElement.closest('.npo-cart-restricted');
            const quantityInput = restrictedContainer ? restrictedContainer.querySelector('.npo-cart-input') : 
                                 document.querySelector(`[data-product-id="${productId}"].npo-cart-input`);
            
            if (quantityInput) {
              quantityInput.setAttribute('data-npo-remaining-quantity', remainingQuantity);
              quantityInput.setAttribute('data-npo-previous-purchases', previousPurchases);
              quantityInput.setAttribute('data-npo-effective-max', remainingQuantity);
              
              // If current quantity exceeds remaining, auto-adjust it
              const currentQuantity = parseInt(quantityInput.value, 10) || 0;
              if (currentQuantity > remainingQuantity) {
                quantityInput.value = Math.max(0, remainingQuantity);
                showNotification(`⚠️ Quantity adjusted to remaining allowed: ${remainingQuantity}`, 'warning');
                
                // Trigger cart update with corrected quantity
                setTimeout(() => {
                  const changeEvent = new Event('keyup', { bubbles: true });
                  changeEvent.key = 'Enter';
                  quantityInput.dispatchEvent(changeEvent);
                }, 500);
              }
              
              // Dispatch event to notify other scripts that restriction data was updated
              quantityInput.dispatchEvent(new CustomEvent('npo-restriction-updated', {
                detail: {
                  maxQuantity,
                  previousPurchases,
                  remainingQuantity,
                  effectiveMax: remainingQuantity
                }
              }));
            }
            
            console.log('[Cart NPO] Updated restriction notice:', {
              productId,
              maxQuantity: maxQuantity || 'unknown',
              previousPurchases: previousPurchases || 0,
              remainingQuantity: remainingQuantity || 0,
              effectiveMax: remainingQuantity || 0
            });
          } else {
            console.log('[Cart NPO] Missing restriction data:', {
              hasMaxQuantity: !!(result.maxQuantityPerCustomer || restriction.maxQuantityPerCustomer),
              hasPreviousPurchases: (result.previousPurchases !== undefined || restriction.previousPurchases !== undefined),
              previousPurchases: result.previousPurchases !== undefined ? result.previousPurchases : restriction.previousPurchases,
              topLevelData: {
                maxQuantityPerCustomer: result.maxQuantityPerCustomer,
                previousPurchases: result.previousPurchases,
                remainingQuantity: result.remainingQuantity
              },
              restrictionLevelData: {
                maxQuantityPerCustomer: restriction.maxQuantityPerCustomer,
                previousPurchases: restriction.previousPurchases,
                remainingQuantity: restriction.remainingQuantity
              }
            });
          }
        }
        
      } catch (error) {
        console.error('[Cart NPO] Error fetching purchase history:', error);
        // Remove loading indicator on error
        textElement.textContent = `📦 Max ${maxQuantity} per customer`;
        textElement.classList.remove('npo-initial-loading');
      }
    });
    
    }, 300); // Debounce delay of 300ms
  }
  
  // Show restriction info immediately when cart loads
  setTimeout(window.updateCartRestrictionNotices, 100);
  
  // Update notices after cart updates
  document.addEventListener('cart:updated', window.updateCartRestrictionNotices);
  
  // Also listen for Shopify cart events
  document.addEventListener('DOMContentLoaded', function() {
    // Early load for immediate UX
    setTimeout(window.updateCartRestrictionNotices, 200);
    
    // Listen for any cart changes
    if (window.Shopify && window.Shopify.theme) {
      // Check for cart changes periodically (less frequent due to debounce)
      setInterval(window.updateCartRestrictionNotices, 15000); // Every 15 seconds
    }
  });
  
  }, 100); // Small delay
}); 